export const DEFAULT_MAX_DOT_COUNT = 16;
